// extracted by mini-css-extract-plugin
export default {"table":"WatchListView_table__k0iHW"};